import { render, staticRenderFns } from "./DesktopSearchInput.vue?vue&type=template&id=01cddf8e"
import script from "./DesktopSearchInput.vue?vue&type=script&lang=js"
export * from "./DesktopSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports